import type { Palette } from '@ant-design/colors'
import {
    blue,
    blueDark,
    cyan,
    cyanDark,
    geekblue,
    geekblueDark,
    gold,
    goldDark,
    green,
    greenDark,
    lime,
    limeDark,
    magenta,
    magentaDark,
    orange,
    orangeDark,
    purple,
    red,
    redDark,
    volcano,
    volcanoDark
} from '@ant-design/colors'

function getPrimaryColor(palette: Palette) {
    return palette[5].toUpperCase()
}

export const usePaletteColors = (color?: string) => {
    const colors = new Map([
        [getPrimaryColor(magenta), magenta],
        [getPrimaryColor(red), red],
        [getPrimaryColor(volcano), volcano],
        [getPrimaryColor(orange), orange],
        [getPrimaryColor(gold), gold],
        [getPrimaryColor(lime), lime],
        [getPrimaryColor(green), green],
        [getPrimaryColor(cyan), cyan],
        [getPrimaryColor(blue), blue],
        [getPrimaryColor(geekblue), geekblue],
        [getPrimaryColor(purple), purple],
        [getPrimaryColor(magentaDark), magentaDark],
        [getPrimaryColor(redDark), redDark],
        [getPrimaryColor(volcanoDark), volcanoDark],
        [getPrimaryColor(orangeDark), orangeDark],
        [getPrimaryColor(goldDark), goldDark],
        [getPrimaryColor(limeDark), limeDark],
        [getPrimaryColor(greenDark), greenDark],
        [getPrimaryColor(cyanDark), cyanDark],
        [getPrimaryColor(blueDark), blueDark],
        [getPrimaryColor(geekblueDark), geekblueDark]
    ])

    return color ? colors.get(color.toUpperCase()) : []
}
